import { AccountView } from "@bitwarden/web-vault/app/models/view/account/account.view";
import { InstitutionView } from "@bitwarden/web-vault/app/models/view/institution/institution.view";
import { EarnTableView } from "../../../models/types/transaction.types";
import { TransactionView } from "../../../models/view/transaction/transaction.view";
import {
  EarnMask,
  EarnVersion,
  TransactionId,
} from "@bitwarden/web-vault/app/models/types/earn.types";
import { EarnVersionTable } from "@bitwarden/web-vault/app/components/tables/earn-tables/tables/version/earn-version.table";

// todo method is too long... remove comments
export function getTransactionRedactionTableViews(
  accountViews: AccountView[],
  transactions: TransactionView[],
  institutionViews: InstitutionView[],
  selectedMask: EarnMask,
): EarnTableView[] {
  if (!selectedMask) {
    return [];
  }
  selectedMask.appliedToSet = new Set<TransactionId>(selectedMask?.appliedToArray);
  return transactions
    ?.map((transaction, index) => {
      const account = accountViews.find((acc) => acc.id === transaction.accountLink.id);
      const institution = institutionViews.find(
        (insto) => insto.id === account.institutionLink.institutionId,
      );
      return {
        id: transaction.id,
        publishedAt: selectedMask.appliedToSet.has(transaction.id)
          ? selectedMask?.publishedAt?.toDateString() || "unpublished"
          : "unpublished",
        description: transaction.description,
        transactionDate: transaction.postDate.toDateString(),
        amount: transaction.quantity.actualQuantity.amount,
        account: account.displayName,
        inOut: transaction.direction,
        currency: transaction.quantity.currency,
        source: transaction.origin,
        accountBalance: "2000",
        institution: institution.name,
      } as EarnTableView;
    })
    .sort((a, b) => {
      // todo clear names here
      const aUnpub = a.publishedAt === "unpublished";
      const bUnpub = b.publishedAt === "unpublished";

      // unpublished rows always first
      if (aUnpub && !bUnpub) {
        return -1;
      }
      if (!aUnpub && bUnpub) {
        return 1;
      }

      // both published, sort by date descending
      if (!aUnpub && !bUnpub) {
        return new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime();
      }

      // both unpublished
      return 0;
    });
}

export function getEarnVersionTableViews(masks: EarnMask[]): EarnVersion[] {
  return masks as unknown as EarnVersion[];
}
